import {observer} from "mobx-react";
import {GameLoadingIndicatorComponent} from "../game-window/loading-indicators/game-loading-indicator.component";
import React from "react";
import {ComponentServicesPick} from "../../services/component-services-pick";
import {withServices} from "../../react-hooks/with-services";

interface CurrentGameContainerComponentProps extends ComponentServicesPick<'gameRunner'> {

}

const ComponentBody: React.FC<CurrentGameContainerComponentProps> = observer((props) => {
    if(props.gameRunner.gameLoadingIndicator) {
        return (<GameLoadingIndicatorComponent/>);
    }

    const currentRunningGame = props.gameRunner.currentRunningGame;
    if(!currentRunningGame) {
        return null;
    }

    return currentRunningGame.renderGame();
})

export const CurrentGameContainerComponent = withServices(ComponentBody, ['gameRunner']);